//Parroquia Vargas
const munVargas = [
  'Caraballeda',
  'Carayaca',
  'Caruao',
  'Catia La Mar',
  'El Junko',
  'La Guaira',
  'Macuto',
  'Maiquetía',
  'Naiguatá',
  'Urimare',
  'Carlos Soublette',
];

export const esVargas = [
  {
    municipio: 'Vargas',
    parroquias: munVargas,
  },
];
